import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';

const useStyles = makeStyles(theme => ({
	footer: {
		backgroundColor: '#1a2942',
		color: '#ffffff',
		padding: '48px 48px 24px',
		[theme.breakpoints.down('sm')]: { padding: '36px 20px 20px' }
	},
	heading: {
		fontWeight: 700,
		fontSize: '1.05rem',
		marginBottom: 16,
		color: '#ffffff'
	},
	tagline: {
		color: 'rgba(255,255,255,0.6)',
		lineHeight: 1.8,
		marginTop: 12,
		maxWidth: 320
	},
	accent: {
		width: 40,
		height: 3,
		backgroundColor: '#0288d1',
		borderRadius: 2,
		marginTop: 14
	},
	link: {
		display: 'block',
		color: 'rgba(255,255,255,0.7)',
		marginBottom: 10,
		fontSize: '0.95rem',
		'&:hover': { color: '#4FC3F7' }
	},
	contactRow: {
		display: 'flex',
		alignItems: 'flex-start',
		marginBottom: 12,
		color: 'rgba(255,255,255,0.7)'
	},
	contactIcon: {
		fontSize: 18,
		marginRight: 10,
		marginTop: 3,
		color: '#4FC3F7'
	},
	bottom: {
		marginTop: 32,
		paddingTop: 20,
		borderTop: '1px solid rgba(255,255,255,0.12)',
		textAlign: 'center',
		color: 'rgba(255,255,255,0.45)',
		fontSize: '0.85rem'
	}
}));

function FooterLayout2(props) {
	const classes = useStyles(props);
	const footerTheme = useSelector(selectFooterTheme);
	const { t } = useTranslation('navigation');

	const links = [
		{ to: '/home', label: t('HOME') },
		{ to: '/products', label: t('PRODUCTS') },
		{ to: '/iso-9001', label: t('ISO') },
		{ to: '/responsible-minerals', label: t('MINERALS') },
		{ to: '/contact', label: t('CONTACT') }
	];

	return (
		<ThemeProvider theme={footerTheme}>
			<footer id="fuse-footer" className={classes.footer}>
				<Grid container spacing={4}>
					<Grid item xs={12} md={5}>
						<Typography className={classes.heading}>{t('footerCompany')}</Typography>
						<Typography className={classes.tagline}>{t('footerTagline')}</Typography>
						<div className={classes.accent} />
					</Grid>

					<Grid item xs={6} md={3}>
						<Typography className={classes.heading}>{t('footerLinks')}</Typography>
						{links.map(l => (
							<Link key={l.to} component={RouterLink} to={l.to} className={classes.link} underline="none">
								{l.label}
							</Link>
						))}
					</Grid>

					<Grid item xs={12} md={4}>
						<Typography className={classes.heading}>{t('footerContactTitle')}</Typography>
						<div className={classes.contactRow}>
							<LocationOnIcon className={classes.contactIcon} />
							<Typography variant="body2">{t('footerAddress')}</Typography>
						</div>
						<div className={classes.contactRow}>
							<PhoneIcon className={classes.contactIcon} />
							<Typography variant="body2">{t('footerPhone')}</Typography>
						</div>
						<div className={classes.contactRow}>
							<EmailIcon className={classes.contactIcon} />
							<Link href={`mailto:${t('footerEmail')}`} color="inherit" underline="hover">
								<Typography variant="body2">{t('footerEmail')}</Typography>
							</Link>
						</div>
					</Grid>
				</Grid>

				<Box className={classes.bottom}>{t('footerRights')}</Box>
			</footer>
		</ThemeProvider>
	);
}

export default React.memo(FooterLayout2);
